<template>
  <div class="hero mt-2">
    <video
      class="video-banner"
      autoplay
      muted
      loop
      playsinline
      webkit-playsinline
    >
      <source src="../../assets/home-page-video.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>

    <!-- Overlay content -->
    <!-- <div class="overlay-content">
      <div class="container">
        <div class="text-hero">
          <h2>Your Heading</h2>
          <p>Your descriptive text.</p>
          <button class="btn">Call to Action</button>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "HomeVideo"
};
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .video-banner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover; // Ensures the video covers the entire area without distorting
    z-index: -1; // Puts the video behind the content
  }

  .overlay-content {
    position: relative;
    z-index: 1; // Keeps the content above the video
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;

    .container {
      .text-hero {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        h2 {
          font-size: 48px;
          color: #fff;
          margin-bottom: 20px;
        }
        p {
          font-size: 18px;
          color: #fff;
        }
        .btn {
          font-size: 16px;
          padding: 10px 20px;
          background-color: #000;
          color: #fff;
          border: none;
          cursor: pointer;
        }
      }
    }
  }
}

/* Adjustments for mobile devices */
@media (max-width: 640px) {
  .hero {
    width: 100%;
    height: auto;

    .video-banner {
      position: relative;
      width: 100%;
      height: auto;
      top: 0;
      left: 0;
      object-fit: contain; // Adjusts the video to fit within the container without cropping
    }

    .overlay-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .overlay-content .text-hero {
      h2 {
        font-size: 32px;
      }
      p {
        font-size: 16px;
      }
      .btn {
        font-size: 14px;
      }
    }
  }
}
</style>
